(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.dms = {
    attach: function (context, settings) {

      var $footer = $('.region-footer__content');
      var $footerHiglightLink = $footer.find('.menu--main .menu__item__link--highlight');
      $footer.append('<div class="region-footer__content__cta"></div>');
      $footer.find('.region-footer__content__cta').append($footerHiglightLink);
      $footerHiglightLink.addClass('btn').addClass('btn--white-t');

      // Use .once() to make sure the function is executed only once even on ajax calls
      // https://www.drupal.org/node/2269515
      $(once('dms','.js-mm-toggle')).click(function(e) {
        $('body').toggleClass('mm-open');
        e.preventDefault();
      });

      // Tracking
      $(once('dms','a[href^="mailto:"]')).addClass('gtm-mail');
      $(once('dms', 'a[href^="tel:"]')).addClass('gtm-phone');

      // Scrol to
      var $root = $('html, body');
      var $scrollTo = $('.js-scroll-to');
      $scrollTo.click(function(e) {
        e.preventDefault();

        var $href = $(this).attr('href');
        var $target = $('#' + getHashFromUrl($href));

        if($target.length) {
          scrollToTarget($root, $target);
        } else {
          var langPrefix = '/' + Drupal.settings.pathPrefix;
          location.href = langPrefix + '#' + getHashFromUrl($href);
        }
      });
      $root.bind('scroll mousedown DOMMouseScroll mousewheel keyup touchstart', function(e) {
        if (e.which > 0 || e.type === 'mousedown' || e.type === 'mousewheel' || e.type === 'touchstart') {
          $root.stop();
        }
      });
    }
  };

  Drupal.behaviors.langSwitcher = {
    attach: function (context, settings) {
      // Load new language
      let $languageSelect = $(once('langSwitcher', '#lang-dropdown'));
      // Set current language
      $languageSelect.val(settings.path.currentLanguage);

      $languageSelect.on('change', function () {
        let $option = $(this).find(':selected');
        document.location = $option.data('url');
      });
    }
  };

  function getHashFromUrl(url){
    return $("<a />").attr("href", url)[0].hash.replace(/^#/, "");
  }

  function scrollToTarget($root, target) {
    $root.animate({
        scrollTop: target.offset().top,
      },
      {
        duration: 750,
      });
  }

})(jQuery, Drupal, window, document);
